/**
 * Select2 Initialization Script
 * Initializes Select2 on all select elements across the site
 */

(function() {
  'use strict';

  /**
   * Initialize Select2 on all select elements
   */
  function initializeSelect2() {
    if (typeof jQuery === 'undefined') {
      console.warn('Select2 requires jQuery to be loaded');
      return;
    }

    if (typeof jQuery.fn.select2 === 'undefined') {
      console.warn('Select2 library not loaded');
      return;
    }

    // Initialize Select2 on all select elements
    jQuery('select').each(function() {
      const $select = jQuery(this);

      // Skip if already initialized
      if ($select.hasClass('select2-hidden-accessible')) {
        return;
      }

      // Get the select element's ID or generate a unique one
      const selectId = $select.attr('id') || 'select-' + Math.random().toString(36).substr(2, 9);

      // Configuration options
      const config = {
        width: '100%',
        minimumResultsForSearch: 5, // Show search box only if more than 5 options
        dropdownAutoWidth: true,
        allowClear: false,
        theme: 'default'
      };

      // Special handling for country/language selectors
      if ($select.attr('name') === 'country_code' || $select.closest('.localization-form').length > 0) {
        config.minimumResultsForSearch = 0; // Always show search for localization
      }

      // Special handling for variant selectors
      if ($select.hasClass('select__select') || $select.closest('.product-form__input').length > 0) {
        config.minimumResultsForSearch = -1; // Hide search for product variants
      }

      // Special handling for sorting/filtering dropdowns
      if ($select.attr('name') === 'sort_by' || $select.closest('.facets').length > 0) {
        config.minimumResultsForSearch = -1; // Hide search for facets
      }

      // Initialize Select2
      try {
        $select.select2(config);
      } catch (error) {
        console.error('Error initializing Select2 on element:', selectId, error);
      }
    });
  }

  /**
   * Reinitialize Select2 when new content is loaded dynamically
   */
  function observeDOMChanges() {
    // Watch for dynamically added select elements
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is a select or contains select elements
            if (node.tagName === 'SELECT') {
              initializeSelect2();
            } else if (node.querySelectorAll) {
              const selects = node.querySelectorAll('select');
              if (selects.length > 0) {
                initializeSelect2();
              }
            }
          }
        });
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Initialize on page load
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initializeSelect2();
        observeDOMChanges();
      });
    } else {
      initializeSelect2();
      observeDOMChanges();
    }
  }

  // Initialize
  init();

  // Expose reinitialize function globally for manual triggering
  window.reinitializeSelect2 = initializeSelect2;

})();